<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  @if (tooltip) {
    <title>{{ tooltip }}</title>
  }
  <path d="M7,11L12,6L17,11H7Z" />
  <path d="M7,13L12,18L17,13H7Z" />
</svg>
